import React, { useCallback, useEffect, useState } from "react";
import { serviceUserQueriesDetail } from "../../../services/UserQueries.service";
import StatusPill from "../../../components/Status/StatusPill.component";
import { useParams } from "react-router";


function useUserQueriesDetailHook() {
  const [data, setData] = useState({});
  const [isUpdateStatusOpen, setIsUpdateStatusOpen] = useState(false);
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);



  useEffect(() => {
    if (id) {
      serviceUserQueriesDetail({ id }).then((res) => {
        if (!res?.error) {
          const response = res?.data;
          setData(response);
        }
      });
    }
  }, [id]);

  const renderList = useCallback (()=>{
    if(id){
      serviceUserQueriesDetail({ id }).then((res) => {
        if (!res?.error) {
          const response = res?.data;
          setData(response);
        }
      });
    }
  }, [id, data])

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseDialog = () => {
    setSelectedImage(null);
  };

  const handleUpdateStatus = () => {
    setIsUpdateStatusOpen(!isUpdateStatusOpen);
  }
 


  const renderStatus = useCallback((status) => {
    if (status === "IN_PROGRESS") {
      return <StatusPill status={"IN PROGRESS"} color={"progress"} />;
    } else if (status === "PENDING") {
      return <StatusPill status={"PENDING"} color={"pending"} />;
    } else if (status === "RESOLVED") {
      return <StatusPill status={"RESOLVED"} color={"active"} />;
    } else if (status === "DISPOSED") {
      return <StatusPill status={"DISPOSED"} color={"high"} />;
    }
  }, []);

  return {
    data,
    isUpdateStatusOpen,
    handleUpdateStatus,
    renderList,
    selectedImage,
    handleImageClick,
    handleCloseDialog,
    renderStatus
  };
}

export default useUserQueriesDetailHook;
